import React from 'react'
import SimpleTable from 'components/Tables/SimpleTable'
import sText from 'components/Text/Text.scss'
import { get } from 'lodash'
import LoadingOverlay from 'components/Loading/LoadingOverlay'

export default ({ node, number, loading }) => {
  const connectedToDifferentFlow = get(number, 'twilioCallFlowId') !== get(node, 'parent.id')
  return (
    <div>
      {loading && <LoadingOverlay />}
      <SimpleTable>
        <div>
          <div>Phone:</div>
          <div>{number && (number.twilioFlowService || number.number)}</div>
        </div>
        <div className={connectedToDifferentFlow ? sText.warn : sText.green}>
          <div>{connectedToDifferentFlow ? 'Linked to another flow' : 'Linked to this flow'}</div>
          <div />
        </div>
      </SimpleTable>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/IncomingCall/IncomingCallDisplay.jsx